import { Presentation } from '../../../core/gameflow/controller/Presentation';
import { GameData } from '../../server/data/GameData';
import { Beheaded } from '../../Beheaded';
import { SplashViewSFSPickAndClick } from '../../modules/splashScreen/views/SplashViewSFSPickAndClick';
import { SoundConfig } from '../../config/sound/SoundConfig';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { SoundManager } from '../../config/sound/SoundManager';
import { SplashController, SplashIndex } from '../../modules/splashScreen/SplashController';
import { SFSState } from './SFSPickAndClickPresentation';

export class SFSPickAndClickResultPresentation extends Presentation {
    protected state: SFSState = new SFSState(SFSState.START);
    protected isCapWin: boolean = false;
    private isBelowStake: boolean = false;

    setGamedData(data: GameData): void {
        SplashController.instance.setData(SplashIndex.OUTRO, data);
        Beheaded.backgroundCharacter.setGameData(data);
        this.isCapWin = data.Win.brokeTheBank;
        this.isBelowStake = data.Win.isWinBelowStake!();
    }

    preStart(): void {
        this.state.set(SFSState.RES);
    }

    createPresentation(skip: Function): void {
        skip(false);
        switch (this.state.value) {
            case SFSState.RES:
                this.onChoose();
                this.state.set(this.isCapWin ? SFSState.DONE : SFSState.OUTRO);
                break;
            case SFSState.OUTRO:
                this.onOutro();
                this.state.set(SFSState.DONE);
                break;
            default:
                this.PresentationState.setInactive();
                break;
        }
    }

    onChoose(): void {
        Beheaded.soundPlayer.stopSound(SoundConfig.FS_OUTRO_LOOP);

        Beheaded.soundPlayer.stopSound(SoundConfig.FS_OUTRO_LOOP_SKULL_HIGHLIGHT);
        Beheaded.soundPlayer.stopSound(SoundConfig.FS_OUTRO_LOOP_SKULL);

        Beheaded.soundPlayer.stopSound(SoundConfig.FS_OUTRO_LOOP_BUTTERFLY_HIGHLIGHT);
        Beheaded.soundPlayer.stopSound(SoundConfig.FS_OUTRO_LOOP_BUTTERFLY);

        if (SplashViewSFSPickAndClick.selected === 1) {
            this.timeline.add(Beheaded.backgroundCharacter.showButtResult());
        } else if (SplashViewSFSPickAndClick.selected === 2) {
            this.timeline.add(Beheaded.backgroundCharacter.showSkullRes());
        }
        this.timeline.to(this, { duration: 0.5 });
    }

    onOutro() {
        SoundManager.fadeOutAmbient(100, 0);
        SlotGame.keypadPlugin.hide(1);
        SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
        SlotGame.keypadPlugin.setWin(Beheaded.model.data.accumulatedRoundWin, true, Beheaded.model.isWinBelowStake);
        if (!this.isBelowStake) SoundManager.playSoundEffect('fsEnd');

        this.timeline.add(
            SplashController.instance.play(SplashIndex.OUTRO, true, true, () => {
                Beheaded.soundPlayer.playSound(SoundConfig.FS_OUTRO_QUIT);
            })
        );
    }

    public done(): void {
        SplashViewSFSPickAndClick.selected = 0;
    }
}
